import React, { useState, useEffect, useCallback } from 'react';

import { IconArrowsMaximize } from '@tabler/icons-react';

import './Carousel/embla.css';
import useEmblaCarousel from 'embla-carousel-react';
import { ModalNotStyled } from 'ui-kit';

import { CarouselContainer } from './Carousel/CarouselContainer';
import { PhotoPreview } from './PhotoPreview';
import { IconButton } from '../../../../../ui-kit';

const imageUrls = [
  'https://images.unsplash.com/photo-1503023345310-bd7c1de61c7d',
  'https://images.unsplash.com/photo-1518791841217-8f162f1e1131',
  'https://images.unsplash.com/photo-1529626455594-4ff0802cfb7e',
  'https://images.unsplash.com/photo-1494790108377-be9c29b29330',
  'https://images.unsplash.com/photo-1535713875002-d1d0cf377fde',
  'https://images.unsplash.com/photo-1503023345310-bd7c1de61c7d',
  'https://images.unsplash.com/photo-1518791841217-8f162f1e1131',
  'https://images.unsplash.com/photo-1529626455594-4ff0802cfb7e',
  'https://images.unsplash.com/photo-1494790108377-be9c29b29330',
  'https://images.unsplash.com/photo-1535713875002-d1d0cf377fde',
  'https://images.unsplash.com/photo-1503023345310-bd7c1de61c7d',
  'https://images.unsplash.com/photo-1518791841217-8f162f1e1131',
  'https://images.unsplash.com/photo-1529626455594-4ff0802cfb7e',
  'https://images.unsplash.com/photo-1494790108377-be9c29b29330',
  'https://images.unsplash.com/photo-1535713875002-d1d0cf377fde',
  'https://images.unsplash.com/photo-1503023345310-bd7c1de61c7d',
  'https://images.unsplash.com/photo-1518791841217-8f162f1e1131',
  'https://images.unsplash.com/photo-1529626455594-4ff0802cfb7e',
  'https://images.unsplash.com/photo-1494790108377-be9c29b29330',
];

export const Thumb = (props: { selected: any; index: any; onClick: any; src: string }) => {
  const { selected, onClick, src } = props;

  return (
    <div className={'embla-thumbs__slide'.concat(selected ? ' embla-thumbs__slide--selected' : '')}>
      <button onClick={onClick} type="button" className="embla-thumbs__slide__number">
        <img
          src={src}
          alt=""
          className={'h-full w-full object-contain transition-all duration-300'.concat(
            !selected ? ' opacity-40 blur-[1px]' : '',
          )}
        />
      </button>
    </div>
  );
};

interface Props {}

export const GalleryComponent = ({}: Props) => {
  const [selectedIndex, setSelectedIndex] = useState(0);
  const slides = Array.from(Array(imageUrls.length).keys());

  return (
    <div>
      <div className="flex h-[32px] w-full items-center justify-between p-2 text-[14px] text-white">
        Address
        <ModalNotStyled
          trigger={
            <IconButton
              variant="icon-only"
              icon={<IconArrowsMaximize size={16} color="#e85ee5" />}
              className="rounded p-2"
              onClick={() => {}}
            />
          }
        >
          {({ closeModal }) => (
            <PhotoPreview src={imageUrls[selectedIndex]} closeModal={closeModal} />
          )}
        </ModalNotStyled>
      </div>

      <CarouselContainer
        slides={slides}
        setSelectedIndex={setSelectedIndex}
        imageUrls={imageUrls}
        selectedIndex={selectedIndex}
      />
      <div className="align-center mt-2 flex w-full justify-center text-[12px]">
        Showing {selectedIndex + 1} of {imageUrls.length}
      </div>
    </div>
  );
};
